import { Button, useTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Webcam from "react-webcam";
import useCamera from "../../hooks/useCamera";
import useScan from "../../hooks/useScan";
import { useStore } from "../../hooks/useStore";
import { useTranslation } from "../../hooks/useTranslation";
import { startScanning, stopScanning } from "../../redux/actions/scanTesseractMrzActions";
import { ISearchUser } from "../../store/types/userTypes";
import Dialog from "../common/Dialog";
import SelectCamera from "../common/SelectCamera";
import NotCamera from "./NotCamera/NotCamera";
import { styleDetectMrz, styleRectangleMrz, useStyles } from "./ScanStyles";

type ScanProps = {
  onScan?: (results: ISearchUser) => void;
};

const Scan = ({ onScan }: ScanProps) => {
  const classes = useStyles();
  const { t, BundleKey } = useTranslation();
  const [isResult, setIsResult] = useState(false);
  const theme = useTheme();
  const webcamRef = React.useRef<Webcam>(null);
  const {
    resetScanQrPdfCamera,
    scanQrPdfCamera,
    recognize,
    enableMrz,
    setEnableMrz,
    isMrz,
    result,
    error,
    reset,
  } = useScan(webcamRef);
  const { getListOfCameras } = useCamera();
  const { cameraStore, mrzStore } = useStore();
  const dispatch = useDispatch();
  const [time, setTime] = useState(0);

  useEffect(() => {
    if (result && onScan) {
      onScan(result);
    }
  }, [result]);

  useEffect(() => {
    getListOfCameras();
    return () => {
      setIsResult(true);
      resetScanQrPdfCamera();
    };
  }, [webcamRef]);

  const startCamera = (deviceId: any) => {
    if (deviceId) scanQrPdfCamera(webcamRef, deviceId);
  };

  const handleClose = () => {
    setIsResult(false);
    startCamera(cameraStore.deviceId);
  };

  useEffect(() => {
    if (mrzStore.scanning) {
      recognize();
    }
  }, [mrzStore.timer, mrzStore.scanning]);

  useEffect(() => {
    if (enableMrz) {
      setTime(time + 1);
      dispatch(startScanning());
    } else {
      dispatch(stopScanning());
    }
  }, [enableMrz]);

  useEffect(() => {
    if (!isResult && cameraStore.deviceId) {
      startCamera(cameraStore.deviceId);
    }
  }, [cameraStore.deviceId]);

  return (
    <div style={{ height: "100%" }}>
      {cameraStore.empty ? (
        <NotCamera />
      ) : (
        <div>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            className={classes.root}
          >
            <Grid item xs={12}>
              <SelectCamera />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.box}>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{
                    deviceId: cameraStore.deviceId,
                  }}
                  className={classes.video}
                />
                <Button
                  onClick={() => setEnableMrz(!enableMrz)}
                  className={enableMrz ? classes.buttonEnable : classes.buttonDisable}
                  color={enableMrz ? "primary" : "default"}
                  variant={"contained"}
                >
                  MRZ
                </Button>
                {enableMrz && webcamRef.current ? (
                  <div
                    style={
                      isMrz
                        ? styleDetectMrz(
                            theme,
                            webcamRef.current?.video?.videoWidth || 640,
                            webcamRef.current?.video?.videoHeight || 480
                          )
                        : styleRectangleMrz(
                            theme,
                            webcamRef.current?.video?.videoWidth || 640,
                            webcamRef.current?.video?.videoHeight || 480
                          )
                    }
                    className={isMrz ? classes.detectMrz : classes.rectangle}
                  ></div>
                ) : null}
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      <Dialog
        open={error !== null}
        onClose={() => {
          reset();
          handleClose();
        }}
        title={error ? error.title : ""}
        labelYes={t(BundleKey.ACTION_ACCEPT)}
      >
        {error?.message}
      </Dialog>
    </div>
  );
};

export default Scan;
